import { DataTable, type DataTableColumn } from '@atrvd/saas-ui'
import type { OrganizationMember } from '@/hooks/useOrganizationAdmin'
import { formatDate } from '@dcp/shared/utils/formatters'
import { queryErrorDisplay, type TableQueryStateProps } from '@/components/common/queryErrorDisplay'

interface OrganizationMembersTableProps extends TableQueryStateProps {
  members: OrganizationMember[]
}

const COLUMNS: DataTableColumn<OrganizationMember>[] = [
  { key: 'fullName', header: 'Name', render: (member) => member.fullName || '—', cellClassName: 'font-medium' },
  { key: 'email', header: 'Email', render: (member) => member.email },
  // `org_admin` reads as "Org Admin": underscores become spaces, CSS `capitalize` capitalizes each word.
  { key: 'role', header: 'Role', render: (member) => member.role.replace(/_/g, ' '), cellClassName: 'capitalize' },
  { key: 'createdAt', header: 'Joined', render: (member) => formatDate(member.createdAt) },
]

/** Admin list of an organization's members: name, email, role and join date. Unpaged. */
export function OrganizationMembersTable({
  members,
  loading,
  refreshing,
  error,
  retrying,
  onRetry,
}: OrganizationMembersTableProps) {
  const { banner, tableError } = queryErrorDisplay({ error, retrying, onRetry }, members.length)
  return (
    <>
      {banner}
      <DataTable
        columns={COLUMNS}
        data={members}
        rowKey={(member) => member.id}
        itemName="members"
        showColumnControls={false}
        loading={loading}
        refreshing={refreshing}
        error={tableError}
        emptyState={<p className="text-center text-muted-foreground">No members found</p>}
      />
    </>
  )
}
